import {NavItem} from "./NavItem";
import {NavItemType} from "./NavItemType";

export const replaceVariables = (template: string, data: any) => {
    return template.replace(/\${(.*?)}/g, (_, key) => data[key] ?? '');
}

export const getPageIndex = (pages: NavItem[], pageId : string) => {
    return pages.findIndex((navItem) => navItem.id === pageId);
}

export const getNavItemPage = (navItem : NavItem | undefined) => {
    return navItem?.type === NavItemType.PAGE ? navItem : navItem?.parent;
}

export const getSectionId = (pageIndex: number, sectionIndex: number) => {
    return `page${pageIndex}-section${sectionIndex}`;
}